
// 七牛云-华北区
// const upload_url = 'http://cdn.hdql.xiaocx.cc/';

// 请求地址
const admin_api = '/admin';

// 上传环境变量上传环境变量【qiniu=七牛云】[ali_oss=阿里云OSS][cos=腾讯云cos]
const upload_type = 'qiniu';
let upload_url = '';
switch(upload_type) {
    case 'qiniu':
        // upload_url = 'https://up-z1.qiniup.com/';
        upload_url = admin_api+'/qiniu/index';
        break;
    case 'ali_oss':
        upload_url = '/admin/ali_oss/index';
        break;
    case 'cos':
        upload_url = '/admin/cos/index';
        break;
}

export default {
    upload_url,
    admin_api,
    upload_type,                    // 上传环境变量
    token: sessionStorage.getItem('access-token') || ''
}



// WEBPACK FOOTER //
// ./src/util/common.js